/**
 * Copyright (C) 2018–2020 HERE Global B.V. and its affiliate(s).
 * All rights reserved.
 *
 * This software and other materials contain proprietary information
 * controlled by HERE and are protected by applicable copyright legislation.
 * Any use and utilization of this software and other materials and
 * disclosure to any third parties is conditional upon having a separate
 * agreement with HERE for the access, use, utilization or disclosure of this
 * software. In the absence of such agreement, the use of the software is not
 * allowed.
 */

import LuiBase from '@here/lui-base'
import scopedCss from 'lui-avatar.scss'
import template from 'lui-avatar.html'

export default class LuiAvatar extends LuiBase {
  static get is() {
    return 'lui-avatar'
  }

  static get css() {
    return scopedCss
  }

  static get template() {
    return template
  }

  static get hasLuiElementsInShadowDom() {
    return false
  }

  onConnected() {
    super.onConnected()
    this.delay(this._applyBrowserSpecificPositioning.bind(this))
  }

  _applyBrowserSpecificPositioning() {
    const CHROME_TEXT_OFFSET_VERTICAL = 1
    const isChrome = navigator.userAgent.indexOf('Chrome') > -1
    const isSafari = !isChrome && navigator.userAgent.indexOf('Safari') > -1

    if (isChrome || isSafari) {
      const textElement = this.shadowRoot.querySelector('.text')
      const avatarElement = this.shadowRoot.querySelector('.default-avatar')
      const imgElement = this.querySelector('img')

      textElement && (textElement.style.top = `${CHROME_TEXT_OFFSET_VERTICAL}px`)
      avatarElement && (avatarElement.style.top = `-${CHROME_TEXT_OFFSET_VERTICAL}px`)
      imgElement && (imgElement.style.top = `-${CHROME_TEXT_OFFSET_VERTICAL}px`)
    }
  }
}



//////////////////
// WEBPACK FOOTER
// ./packages/lui-avatar/lui-avatar.js
// module id = 164
// module chunks = 0 1 37